export default __webpack_public_path__ + "static/N0234-3ec94501ea5edca8b613841d64669ba4.png";